import React, {useEffect, useRef, useState} from "react"
import {Link, useParams, useLocation, useNavigate, useOutletContext} from "react-router-dom";
import api, {requestFailed} from "../Scripts/api";
import PostTag from "../Components/PostTag";
import StepList from "../Components/StepList"
import Loading from "../Components/Loading";

function Post() {

    const oc = useOutletContext().oc
    const location = useLocation().pathname
    const {postID} = useParams()
    const modal = !location.startsWith("/post")
    const navigate = useNavigate()
    const postRef = useRef()
    const [title, setTitle] = useState()
    const [steps, setSteps] = useState()
    const author = postID.split('-')[0]
    const [tags, setTags] = useState()
    const [likes, setLikes] = useState({liked: false, count: 0})
    const [loading, setLoading] = useState(true)
    const [confirmingDelete, setConfirmingDelete] = useState(false)
    const [likeBusy, setLikeBusy] = useState(false)
    const [mobile, setMobile] = useState(typeof window !== "undefined" ? window.innerWidth <= 767 : false)

    const getPost = () => {
        api.get(`/api/getpost`, {
            params: {url: postID}
        }).then((response) => {
            if (response.data.title && response.data.steps) {
                setTitle(response.data.title)
                setSteps(response.data.steps)
                setTags(response.data.tags)
            } else if (response.data.error == 404) navigate("/404")
            setLoading(false)
        }).catch((error) => {
            requestFailed(error)
            setLoading(false)
        })
    }

    const deletePost = () => {
        if (!confirmingDelete) {
            setConfirmingDelete(true)
            return
        }
        api.post(`/api/deletepost`, {
            postID: postID
        }).then(() => {
            if (modal) navigate(-1)
            else navigate("/explore")
        }).catch(requestFailed)
    }

    const getLikes = () => {
        if (!oc.accountID) return
        api.get(`/api/getlikes`, {
            params: {accountID: oc.accountID, postID: postID}
        }).then((response) => {
            setLikes({liked: response.data.liked, count: response.data.likes})
        }).catch(requestFailed)
    }

    const likePost = () => {
        if (likeBusy) return
        setLikeBusy(true)
        api.post(`/api/likepost`, {
            postID: postID
        }).then(() => {
            getLikes()
        }).catch(requestFailed).finally(() => setLikeBusy(false))
    }

    const unlikePost = () => {
        if (likeBusy) return
        setLikeBusy(true)
        api.post(`/api/unlikepost`, {
            postID: postID
        }).then(() => {
            getLikes()
        }).catch(requestFailed).finally(() => setLikeBusy(false))
    }

    const goExplore = () => {
        navigate("/explore")
    }

    const goTag = (tag) => {
        navigate("/explore/tags=" + tag)
    }

    useEffect(() => {
        if (!modal) navigate("/post/" + postID)
        else {
            getPost()

            if (typeof document !== 'undefined') {
                const handleAllClicks = (event) => {
                    if (!postRef.current.contains(event.target)) navigate(-1)
                }
                document.addEventListener("click", handleAllClicks)
                return () => {
                    document.removeEventListener("click", handleAllClicks)
                }
            }
        }
    }, [])

    useEffect(() => {
        getLikes()
    }, [oc.accountID])

    useEffect(() => {
        if (typeof window === "undefined") return
        const handleResize = () => setMobile(window.innerWidth <= 767)
        window.addEventListener("resize", handleResize)
        return () => window.removeEventListener("resize", handleResize)
    }, [])

    if (loading) return(<Loading/>)
    else return (
        <div  className={modal ? "modal" : 'nonmodal'}>
            <div>
                {!modal && mobile &&
                    <div id="mobilepostoptions">
                        <button id="closemodal" onClick={goExplore}>&lt; explore</button>
                        {oc.account == author && <button id="postdelete" onClick={deletePost}>&lt; {confirmingDelete ? "confirm delete?" : "delete"} </button>}
                    </div>
                }
                {!modal && !mobile && <button id="closemodal" onClick={goExplore}>&lt; explore</button>}
                <div ref={postRef} className="post">
                    {modal && oc.account == author &&
                        <button id="postdeletemodal" onClick={deletePost}>{confirmingDelete ? "confirm delete?" : "delete"}</button>
                    }
                    {modal && oc.account && oc.account != author &&
                        <button disabled={likeBusy} id={likes.liked ?"postunlikemodal" : "postlikemodal"} onClick={likes.liked ? unlikePost : likePost}>{likes.liked ? "<3 unlike"  : "<3 like"}</button>
                    }
                    <h1>{title}</h1>
                    <h2>by {author === "AI" ? "AI" : <Link id="postauthor" to={"/@" + author + "/profile"}>{author}</Link>}</h2>
                    {tags?.map((item, key) => <PostTag key={key} className="posttag" tag={item} onClick={() => goTag(item)}/>)}
                    {steps &&
                        <StepList steps={steps}/>
                    }
                </div>
                {!modal && !mobile && oc.account == author &&
                    <button id="postdelete" onClick={deletePost}>&lt; {confirmingDelete ? "confirm delete?" : "delete"} </button>
                }
                {!modal && oc.account && oc.account != author &&
                    <button disabled={likeBusy} id={likes.liked ? "postunlike" : "postlike"} onClick={likes.liked ? unlikePost : likePost}>{likes.liked ? "<3 unlike"  : "<3 like  "}</button>
                }
            </div>
        </div>
    )
}

export default Post;
